import { useEffect, useState } from "react";

function MobileBanner() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if (isMobile) {
      setIsOpen(true);
    }
  }, []);

  return (
    <div>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-black opacity-50"></div>
          <div className="bg-white px-6 py-8 rounded-lg shadow-lg z-10 relative min-w-80 min-h-80 mx-4">
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="absolute top-0 right-0 p-2 text-gray-800 hover:text-gray-900 focus:outline-none focus:shadow-outline-blue"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <p className="text-lg font-semibold mb-4">
              JusaMusha lets you send airtime and buy electricity instantly, at
              any local shop - no app, sign-up or bank account required.
            </p>
            <div className="space-y-8 pb-2">
              <ActionButton>Buy airtime</ActionButton>
              <ActionButton>Buy Zesa</ActionButton>
              <p
                className="text-gray-600 underline text-center"
                onClick={() => setIsOpen(false)}
              >
                Read more about us
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ActionButton({ children }) {
  return (
    <a
      href="https://wa.me/27769965252"
      target="_blank"
      rel="noopener noreferrer"
      className="w-full py-3 px-2 font-bold text-white uppercase rounded-full hover:bg-amber-dark bg-amber hover:bg-green-600 focus:outline-none focus:shadow-outline-blue flex items-center justify-center"
    >
      {children}
    </a>
  );
}

export default MobileBanner;
